export default __webpack_public_path__ + "static/media/solace-circle-color.244abcd4.svg";